import DateRangeFilter from 'components/ReactTable/Filters/DateRangeFilter';
import MultiSelectFilter from 'components/ReactTable/Filters/MultiSelectFilter';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const statementUploadsTabColumnDefs = () => [
  {
    Header: 'File Name',
    accessor: 'originalFileName',
    className: 'col-40p',
  },
  {
    Header: 'Status',
    accessor: 'documentUploadStatus',
    Filter: MultiSelectFilter,
    className: 'col-10p',
  },
  {
    Header: 'Date Uploaded',
    accessor: 'documentUploadDate',
    Cell: ({ row }) => row.original.documentUploadDateDisplay || '',
    Filter: DateRangeFilter,
    className: 'col-15p',
    disableSortBy: false
  },
  {
    Header: 'Uploaded By',
    accessor: 'uploadedBy',
    disableSortBy: true,
    className: 'col-10p',
    disableFilters: true
  },
  {
    Header: 'Files',
    accessor: 'fileCount',
    className: 'col-5p',
    disableFilters: true
  },
  {
    Header: 'Forms',
    accessor: 'formCount',
    className: 'col-5p',
    disableFilters: true
  },
  {
    Header: 'Supporting Docs',
    accessor: 'supportingDocumentCount',
    className: 'col-10p',
    disableFilters: true
  },
];

export default statementUploadsTabColumnDefs;
